module.exports = __webpack_public_path__ + "img/yeyeko.b8ee8946.jpg";